import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { TChatbotEnvironmentVars } from '@monorepo/types';
import { TChatbotConfig } from './types/chatbot.types';
import { UiModule } from '@monorepo/ui';
import { HighchartsChartModule } from 'highcharts-angular';
import { MarkdownModule } from 'ngx-markdown';
import { ChatInsightsComponent } from './chat-insights/chat-insights.component';
import { ChatResponseComponent } from './chat-response/chat-response.component';
import { ChatRunStagesComponent } from './chat-run-stages/chat-run-stages.component';
import { ChatUiContainerComponent } from './chat-ui-container/chat-ui-container.component';
import { ChatWelcomeComponent } from './chat-welcome/chat-welcome.component';
import { ChatbotLauncherComponent } from './chatbot-launcher/chatbot-launcher.component';
import { ChatbotPanelComponent } from './chatbot-panel/chatbot-panel.component';
import { ChatbotEnvironmentService } from './services/chatbot-environment.service';
import { ChatbotSessionService } from './services/chatbot-session.service';
import { ChatbotWebSocketService } from './services/chatbot-websocket.service';

@NgModule({
  imports: [CommonModule, IonicModule, UiModule, HighchartsChartModule, MarkdownModule.forRoot()],
  declarations: [
    ChatbotLauncherComponent,
    ChatbotPanelComponent,
    ChatUiContainerComponent,
    ChatResponseComponent,
    ChatRunStagesComponent,
    ChatInsightsComponent,
    ChatWelcomeComponent,
  ],
  exports: [ChatbotLauncherComponent],
})
export class ChatbotModule {
  static forRoot(
    chatbotEnvironment: TChatbotEnvironmentVars,
    chatbotConfig: TChatbotConfig,
  ): ModuleWithProviders<ChatbotModule> {
    return {
      ngModule: ChatbotModule,
      providers: [
        ChatbotEnvironmentService,
        ChatbotWebSocketService,
        // [NOTE]: uncomment to use mock data
        // {
        //   provide: ChatbotWebSocketService,
        //   useClass: USE_CHATBOT_MOCK ? ChatbotMockWebSocketService : ChatbotWebSocketService,
        // },
        ChatbotSessionService,
        {
          provide: 'chatbotEnvironment',
          useValue: chatbotEnvironment,
        },
        {
          provide: 'chatbotConfig',
          useValue: chatbotConfig,
        },
      ],
    };
  }
}
